import { Translatable } from "@icc/shared/helpers";

/** Wieszak blokady */
export class Bracket {
    id: number | null;
    indexNo?: string;
    extId?: string;
    @Translatable({ model: 'WindowAccessories' })
    name?: string;
    /** Ilości */
    amounts: {
        /** Minimalna szerokość */
        min_width: number;
        /** Maksymalna szerokość */
        max_width: number;
        /** Ilość */
        amount: number;
        /** Typ wyboru */
        selection_type?: 'mandatory' | 'suggested' | 'optional';
        /** Czy wyświetlać komunikat o dostępności */
        show_selection_type_announcement?: boolean;
    }[];
    /** Przypisane typy skrzynki */
    blindBoxTypes?: number[];
    /** Wybrany */
    checked?: boolean;
    /** Wybrany przez użytkownika */
    userChecked?: boolean;
    /** Usunięty przez użytkownika */
    userRemoved?: boolean;
    /** Waga */
    weight?: number;
    /** Kolejność */
    order: number;
    /** Typ wyboru - stare oferty */
    selectionType?: 'mandatory' | 'suggested' | 'optional'
    /** Minimalna szerokość - stare oferty */
    minWidth?: number;
    /** Maksymalna szerokość - stare oferty */
    maxWidth?: number;
    /** Liczba wieszaków - stare oferty */
    amount?: number
}

export interface IccBracket {
    id: number;
    indexNo?: string;
    extId?: string;
    name: string;
    /** Ilości */
    amounts: {
        /** Minimalna szerokość */
        min_width: number;
        /** Maksymalna szerokość */
        max_width: number;
        /** Ilość */
        amount: number;
        /** Typ wyboru */
        selection_type?: 'mandatory' | 'suggested' | 'optional';
        /** Czy wyświetlać komunikat o dostępności */
        show_selection_type_announcement?: boolean;
    }[];
    blindBoxTypes: number[];
    /** Waga */
    weight?: number;
    /** Kolejność */
    order: number;
}
